import React from "react";

import { Line } from "@visx/shape";

import type { XYChartGuideProps } from "./types";

export const XYChartGuide = ({
  verticalGuidelinePosition,
  yMax,
}: XYChartGuideProps) => (
  <Line
    from={{ x: verticalGuidelinePosition, y: 0 }}
    to={{ x: verticalGuidelinePosition, y: yMax }}
    stroke={"#0C2836"}
    strokeWidth={1}
    pointerEvents="none"
    strokeDasharray="3,5"
  />
);
